var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeadingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33026 14H6.6636L7.33026 9.33333H4.99693C4.41026 9.33333 4.77693 8.83333 4.79026 8.81333C5.65026 7.29333 6.9436 5.02667 8.67026 2H9.33693L8.67026 6.66667H11.0103C11.2769 6.66667 11.4236 6.79333 11.2769 7.10667C8.6436 11.7 7.33026 14 7.33026 14Z",
    fill: "#181E25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeadingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leading-icon.3a7f1c8dc2ea8df7478a04aedd0f7578.svg";